import { Component } from '@angular/core';
import { FingeringDiagramBaseComponent } from '../fingering-diagram-base/fingering-diagram-base.component';

@Component({
  selector: 'app-emeo-diagram-clarinet-v1',
  templateUrl: './emeo-diagram-clarinet-v1.component.svg',
  styleUrls: ['./emeo-diagram-clarinet-v1.component.scss']
})
export class EmeoDiagramClarinetV1Component extends FingeringDiagramBaseComponent {

  constructor()
  { 
    super();
  }


}
